<template>
  <div class="analysis-page">
    <div class="overall">
      <div class="overall-item">
        <p class="title-disp">问卷浏览量</p>
        <span class="count-disp">{{ viewCount }}</span>
        <p class="desc-disp">问卷实时浏览量</p>
      </div>
      <div class="overall-item">
        <p class="title-disp">问卷有效回收量</p>
        <span class="count-disp">{{ validCount }}</span>
        <p class="desc-disp">
          <span>未完成：{{ notFinishCount }}</span>
          <span>无效：{{ invalidCount }}</span>
          <span>总回收：{{ recycleCount }}</span>
        </p>
      </div>
      <div class="overall-item">
        <p class="title-disp">回收率</p>
        <span class="count-disp">{{ parseInt(collectRate * 100) }}%</span>
      </div>
      <div class="overall-item">
        <p class="title-disp">平均完成时间</p>
        <span class="count-disp">{{ timeAvg }}</span>
      </div>
    </div>
    <!-- <vue-highcharts :highcharts="Highcharts" class="chartbox mapChart" :options="mapOptions"></vue-highcharts> -->
    <vue-highcharts
      class="chartbox recircle-chart"
      :options="options"
    ></vue-highcharts>
    <vue-highcharts
      class="chartbox recircle-chart"
      :options="rateOptions"
    ></vue-highcharts>
  </div>
</template>

<script>
import VueHighcharts from "vue2-highcharts";
import http from "../utils/http";
import Highmaps from "../../node_modules/highcharts/modules/map.js";
import Highcharts from "highcharts";
import chinaJson from "../assets/china.geo.json";
Highmaps(Highcharts);

export default {
  name: "Analysis",
  data() {
    return {
      interface: {
        overview: `/stat/overview`,
      },
      newest: true,
      viewCount: 0,
      recycleCount: 0,
      collectRate: 0,
      validCount: 0,
      notFinishCount: 0,
      invalidCount: 0,
      timeAvg: 0,
      dailyCountList: {},
      addressCountList: [],
      answerRate: [],
      Highcharts,
    };
  },
  mounted() {
    this.getData();
  },
  props: ["surveyTitle"],
  computed: {
    SURVEY_ID() {
      return this.$route.query.id;
    },
    options() {
      return {
        chart: {
          marginTop: 70,
        },
        title: {
          text: "问卷回收量",
          style: { "font-size": "14px" },
        },
        yAxis: {
          title: {
            text: " ",
          },
        },
        xAxis: {
          categories: [...Object.keys(this.dailyCountList)],
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        colors: ["#FF552E"],
        credits: {
          enabled: false,
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
        series: [
          {
            name: this.surveyTitle,
            data: [...Object.values(this.dailyCountList)],
          },
        ],
      };
    },
    rateOptions() {
      return {
        chart: {
          type: "area",
          marginTop: 70,
        },
        title: {
          text: "问卷填答率",
          style: { "font-size": "14px" },
        },
        yAxis: {
          title: {
            text: " ",
          },
          max: 1,
        },
        xAxis: {
          categories: this.answerRate.map((val, i) => {
            return "第" + (i + 1) + "题";
          }),
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        colors: ["#FF552E"],
        credits: {
          enabled: false,
        },
        tooltip: {
          pointFormatter: function () {
            return (this.y * 100).toFixed(2) + "%";
          },
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
        series: [
          {
            name: this.surveyTitle,
            data: this.answerRate,
          },
        ],
      };
    },
    mapOptions() {
      return {
        title: {
          text: "地域分布",
          style: { "font-size": "14px" },
        },
        chart: {
          type: "map",
        },
        legend: {
          enabled: false,
        },
        xAxis: {
          tickWidth: 0,
          lineWidth: 0,
          labels: {
            enabled: false,
          },
        },
        yAxis: {
          title: "",
          gridLineWidth: 0,
          labels: {
            enabled: false,
          },
        },
        credits: {
          enabled: false,
        },
        colors: ["#FF552E"],
        mapNavigation: {
          enabled: false,
          buttonOptions: {
            verticalAlign: "bottom",
          },
        },
        colorAxis: {
          tickPixelInterval: 100,
        },
        series: [
          {
            data: this.addressCountList || [],
            mapData: chinaJson,
            joinBy: "name",
            keys: ["name", "value"],
            name: "问卷回收量",
            states: {
              hover: {
                color: "#a4edba",
              },
            },
            dataLabels: {
              enabled: false,
              format: "{point.properties.postal}",
            },
          },
        ],
      };
    },
  },
  components: {
    VueHighcharts,
  },
  methods: {
    getData() {
      http
        .get(this.interface.overview, {
          surveyId: this.SURVEY_ID,
        })
        .then((response) => {
          const { code, data, message } = response;
          if (code === 1) {
            this.newest = data.newest;
            this.viewCount = data.viewCount;
            this.recycleCount = data.recycleCount;
            this.collectRate = data.collectRate;
            this.validCount = data.validCount;
            this.invalidCount = data.invalidCount;
            this.notFinishCount = data.notFinishCount;
            this.timeAvg = this.formatTime(data.timeAvg);
            this.answerRate = data.answerRate;
            this.dailyCountList = data.dailyCountList;
            const tempArr = [];
            for (const [key, val] of Object.entries(data.addressCountList)) {
              tempArr.push([key, val]);
            }
            this.addressCountList = tempArr;
          } else {
            MSG.error(message);
          }
        });
    },
    formatTime(result) {
      const h =
        Math.floor(result / 3600) > 0 ? `${Math.floor(result / 3600)}时` : "";
      const m =
        Math.floor((result / 60) % 60) > 0
          ? `${Math.floor((result / 60) % 60)}分`
          : "";
      const s = `${Math.floor(result % 60)}秒`;
      return (result = h + m + s);
    },
  },
};
</script>

<style lang="scss">
.analysis-page {
  max-width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  .chartbox {
    width: calc(100% - 500px);
    height: 400px;
    margin: 10px 0;
    float: left;
    &.recircle-chart {
      width: 100%;
    }
  }
  .chartbox {
    border: 1px solid #e7e7e7;
    box-shadow: 1px 1px 2px #e7e7e7;
    border-radius: 0;
    padding: 12px 0;
    background-color: #fff;
  }
  .chartarea {
    width: 475px;
    height: 400px;
    margin: 10px 0;
    float: left;
  }
  .mapChart {
    height: 400px;
  }
  .overall {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    .overall-item {
      width: 24%;
      color: #333;
      float: left;
      height: 192px;
      padding: 20px;
      background-color: #fff;
      border: 1px solid #e7e7e7;
      box-shadow: 1px 1px 2px #e7e7e7;
    }
    .count-disp {
      line-height: 50px;
      font-size: 40px;
      margin-top: 30px;
      display: block;
      text-align: center;
    }
    .desc-disp {
      color: #999;
      text-align: center;
      margin-top: 15px;
      font-size: 12px;
    }
  }
  .title-disp {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/analysis.vue